module.exports = __webpack_public_path__ + "static/media/ajax-Loader.a9e4fbab.gif";